var render = function (_h,_vm) {var _c=_vm._c;return (_vm.bold)?_c('b',[_vm._v("₽")]):_c('span',[_vm._v("₽")])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Rub.vue?vue&type=template&id=5cb6952b&functional=true&
// module id = 619
// module chunks = 2